import { getMeGetConfigQueryKey, getMeOptions, getMeQueryKey } from '@/client/@tanstack/react-query.gen'
import type { GetMeGetConfigResponse, GetMeResponse } from '@/client/types.gen'
import { isInGame } from '@/lib/game'
import { useStore } from '@/store'
import { readCache } from '@/store/action'
import { useQuery } from '@tanstack/react-query'

export const getUserInfo = () => {
  //Read userInfo cache
  const data = readCache(getMeQueryKey()) as GetMeResponse
  return data
}

export const useUserInfo = () => {
  //Subscribe to userInfo cache, re-renders when it's updated (checkin/share/claim...)
  const loginSuccess = useStore((state) => state.loginSuccess)
  const { data } = useQuery({
    ...getMeOptions(),
    enabled: !!((isInGame() && loginSuccess) || !isInGame()),
  })
  return data as GetMeResponse
}

// `userLoaded` in the store also flips true when the unrelated getConfig
// query resolves, so it can go true before /me itself has settled — use this
// (same queryKey, so no extra request) whenever you need to know specifically
// whether the /me fetch itself is still pending, e.g. before gating on
// userInfo?.user?.id.
export const useUserInfoStatus = () => {
  const loginSuccess = useStore((state) => state.loginSuccess)
  const { status } = useQuery({
    ...getMeOptions(),
    enabled: !!((isInGame() && loginSuccess) || !isInGame()),
  })
  return status
}

export const getRemainingTicket = (userInfo?: GetMeResponse) =>
  (userInfo?.userExtension?.ticket ?? 0) -
  (userInfo?.userExtension?.usedTicket ?? 0)

export const getConfig = () => {
  //Read getConfig cache
  const data = readCache(getMeGetConfigQueryKey()) as GetMeGetConfigResponse
  return data
}

// export const getUserState = () => {
//   const data = readCache(getStateQueryKey()) as GetStateResponse
//   return data
// }

// export const useUserInfo = (options?: Partial<UseQueryOptions>) => {
//   const userData = $api.useQuery('get', '/me', {}, {
//     enabled: true,
//     queryHash: 'UserInfo',
//   })
//   return userData
// }

// export const useUserInfo = (options?: Partial<UseQueryOptions>) => {
//   let opts = {
//     queryKey: [queryKey],
//     queryFn: async (): Promise<UserData> => {
//       const [resUser, resStore] = await Promise.all([
//         client.GET('/api/users'),
//         client.GET('/api/store')
//       ]);

//       return {
//         userInfo: (resUser?.data?.user || {})as User,
//         userShop: (resStore?.data?.userStore || {}) as UserStore
//       }
//     }
//   }
//   Object.assign(opts, options);

//   return useQuery(opts)
// }
